define('views/modules/goal/edit/goal-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // Views
    'views/modules/goal/edit/goal-edit-form',
    'views/parts/menu/menu-save-action',
    // templates
    'text!templates/modules/goal/edit/goal-edit-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VGoalEditForm,
    VMenuSaveAction,
    // templates
    TGoalEditContent
) {

    var VGoalEditContent = Backbone.View.extend({
        template: TGoalEditContent,

        regions: {
            root: ".goal-edit-content",
            menu: ".menu-actions",
            form: ".goal-edit-form",
        },

        initialize: function(options) {

            this.profile = options.profile;

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    onSave: this.onSave,
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VGoalEditForm({
                    model: this.model,
                    profile: this.profile
                }),
            };

            this.listenTo(view.form, {
                'form:success': this.onSuccess,
                'model:change': this.onModelChange,
            });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function(isDirty) {
            this.view.menu.toggleSaveButton(!isDirty);
        },

        onSave: function() {
            this.view.form.submit();
        },

        onSuccess: function() {
            this.trigger('form:success');
        },

    });

    return VGoalEditContent;

});

